import {
  createSlice,
  createAsyncThunk,
  miniSerializeError,
  SerializedError,
} from "@reduxjs/toolkit";
import { LOADING_STATE } from "../types/constants";
import authService from "src/services/authService";
import {
  CPT_AUDITOR_LDAP_GROUP,
  GENERAL_USER_LDAP_GROUP,
  CPT_AUDITOR_ADMIN_LDAP_GROUP,
} from "src/constants";

export const SIMULATE_GENERAL_USER_KEY = "X-Simulate-General-User";

export type UserState = {
  token: string;
  alias: string;
  lastName: string;
  firstName: string;
  email: string;
  ldap: string[];
  userLoading: LOADING_STATE;
  authError: SerializedError | null;
  hasPermission: boolean;
  pageLastLoadTimestamp: number;
  isLoading: boolean;
};

const initialState: UserState = {
  token: "",
  alias: "",
  lastName: "",
  firstName: "",
  email: "",
  ldap: [],
  userLoading: "pending",
  authError: null,
  hasPermission: true,
  pageLastLoadTimestamp: 0,
  isLoading: false,
};

/**
 * get the authenticated user
 * @returns {Object}
 */
export const getUser = createAsyncThunk("user/getUser", async () => {
  return authService.login();
});

const { reducer, actions } = createSlice({
  name: "user",
  initialState,
  reducers: {
    loginAsGeneralUser: (state) => {
      localStorage.setItem(SIMULATE_GENERAL_USER_KEY, state.alias);
      window.location.reload();
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getUser.pending, (state) => {
      state.userLoading = "pending";
    });
    // Add reducers for additional action types here, and handle loading state as needed
    builder.addCase(getUser.fulfilled, (state, { payload }) => {
      const { alias, token, email, firstName, lastName, ldap } = payload;
      state.token = token;
      state.alias = alias;
      const simulateUser = localStorage.getItem("X-Simulate-General-User");
      if (typeof simulateUser === "string" && simulateUser) {
        state.alias = simulateUser;
        // state.ldap = [GENERAL_USER_LDAP_GROUP];
        state.ldap = [
          GENERAL_USER_LDAP_GROUP,
          CPT_AUDITOR_LDAP_GROUP,
          CPT_AUDITOR_ADMIN_LDAP_GROUP,
        ];
      } else {
        state.alias = alias;
        state.ldap = ldap;
      }
      state.email = email;
      state.firstName = firstName;
      state.lastName = lastName;
      state.userLoading = "fulfilled";
      state.pageLastLoadTimestamp = Date.now();
      if (state.ldap.length === 0) {
        state.hasPermission = false;
      }
      // TODO: add JWT token to api header
    });
    builder.addCase(getUser.rejected, (state, { error }) => {
      state.authError = miniSerializeError(error);
      state.userLoading = "rejected";
      state.hasPermission = false;
    });
  },
});

export const { loginAsGeneralUser } = actions;

export default reducer;
